var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "white" },
    [
      _vm.select
        ? _c("v-select", {
            ref: "select",
            attrs: {
              value: _vm.dates,
              label: "Date Range",
              "prepend-inner-icon": "today",
              items: _vm.dates,
              readonly: "",
              outlined: _vm.outlined,
              "hide-details": "auto",
              clearable: _vm.clearable,
              outlined: "",
              disabled: _vm.disabled,
              multiple: "",
              dense: "",
            },
            on: {
              "click:append": function ($event) {
                _vm.menu = !_vm.menu
              },
              "click:clear": function ($event) {
                return _vm.clear()
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "selection",
                  fn: function ({ item }) {
                    return [
                      _c("v-chip", { attrs: { small: "" } }, [
                        _c("strong", [_vm._v(_vm._s(item))]),
                      ]),
                    ]
                  },
                },
              ],
              null,
              false,
              35872563
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c("v-date-picker", {
        staticClass: "transparent",
        attrs: {
          type: _vm.month ? "month" : "date",
          noTitle: "",
          label: "Date Range",
          clearable: "",
          "hide-details": "",
          max: _vm.max ?? null,
          disabled: _vm.disabled,
          range: "",
          "full-width": "",
          "picker-date": _vm.pickerDate,
        },
        on: {
          "update:picker-date": function ($event) {
            _vm.pickerDate = $event
          },
          change: function ($event) {
            _vm.menu = false
          },
          input: function ($event) {
            let getDates = $event.sort()
            _vm.$emit("input", {
              rangeStart: getDates[0] ?? "0",
              rangeEnd: getDates[1],
            })
          },
        },
        model: {
          value: _vm.dates,
          callback: function ($$v) {
            _vm.dates = $$v
          },
          expression: "dates",
        },
      }),
      _vm._v(" "),
      _c(
        "v-col",
        [
          _c(
            "v-chip-group",
            {
              attrs: { column: _vm.$vuetify.breakpoint.mdAndUp },
              model: {
                value: _vm.selectedOption,
                callback: function ($$v) {
                  _vm.selectedOption = $$v
                },
                expression: "selectedOption",
              },
            },
            _vm._l(_vm.presetOptions, function (option) {
              return _c(
                "v-chip",
                {
                  key: option.display,
                  class: option.class,
                  attrs: { small: "" },
                  on: {
                    click: function ($event) {
                      ;[option.method(), (option.loading = true)]
                    },
                  },
                },
                [
                  _c("strong", [_vm._v(_vm._s(option.display))]),
                  _vm._v(" "),
                  option.loading
                    ? _c("v-progress-circular", {
                        staticClass: "ml-2",
                        attrs: {
                          size: "12",
                          width: "2",
                          indeterminate: "",
                          color: "primary",
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }